module.exports = __webpack_public_path__ + "static/media/Delete.5f3d9f2d.svg";